module.exports = __webpack_public_path__ + "img/roadmap.116e7037.svg";